<ng-content select="[tiimeTimelineItemDate]"></ng-content>
<div class="tiime-timeline-item-gutter">
  <div [ngClass]="[color, 'event--color']"></div>
  <div class="tiime-timeline-item-line"></div>
</div>
<div class="event--infos">
  <ng-content select="[tiimeTimelineItemTitle]"></ng-content>
  <ng-content select="[tiimeTimelineItemDescription]"></ng-content>
</div>
